/**
 * Common ISO 4217 currencies used as suggestions in the Currencies settings panel.
 * Hantera does not constrain currencies to this list — any code is accepted (e.g. BTC,
 * LOYALTY_POINTS) — but these provide friendlier defaults when known.
 */

export interface IsoCurrency {
  code: string
  label: string
  decimals: number
}

export const ISO_CURRENCIES: IsoCurrency[] = [
  { code: 'AED', label: 'United Arab Emirates Dirham', decimals: 2 },
  { code: 'AUD', label: 'Australian Dollar', decimals: 2 },
  { code: 'BRL', label: 'Brazilian Real', decimals: 2 },
  { code: 'CAD', label: 'Canadian Dollar', decimals: 2 },
  { code: 'CHF', label: 'Swiss Franc', decimals: 2 },
  { code: 'CNY', label: 'Chinese Yuan', decimals: 2 },
  { code: 'CZK', label: 'Czech Koruna', decimals: 2 },
  { code: 'DKK', label: 'Danish Krone', decimals: 2 },
  { code: 'EUR', label: 'Euro', decimals: 2 },
  { code: 'GBP', label: 'British Pound', decimals: 2 },
  { code: 'HKD', label: 'Hong Kong Dollar', decimals: 2 },
  { code: 'HUF', label: 'Hungarian Forint', decimals: 2 },
  { code: 'ILS', label: 'Israeli New Shekel', decimals: 2 },
  { code: 'INR', label: 'Indian Rupee', decimals: 2 },
  { code: 'ISK', label: 'Icelandic Króna', decimals: 0 },
  { code: 'JPY', label: 'Japanese Yen', decimals: 0 },
  { code: 'KRW', label: 'South Korean Won', decimals: 0 },
  { code: 'MXN', label: 'Mexican Peso', decimals: 2 },
  { code: 'NOK', label: 'Norwegian Krone', decimals: 2 },
  { code: 'NZD', label: 'New Zealand Dollar', decimals: 2 },
  { code: 'PLN', label: 'Polish Złoty', decimals: 2 },
  { code: 'RON', label: 'Romanian Leu', decimals: 2 },
  { code: 'RUB', label: 'Russian Ruble', decimals: 2 },
  { code: 'SEK', label: 'Swedish Krona', decimals: 2 },
  { code: 'SGD', label: 'Singapore Dollar', decimals: 2 },
  { code: 'THB', label: 'Thai Baht', decimals: 2 },
  { code: 'TRY', label: 'Turkish Lira', decimals: 2 },
  { code: 'TWD', label: 'New Taiwan Dollar', decimals: 2 },
  { code: 'USD', label: 'United States Dollar', decimals: 2 },
  { code: 'ZAR', label: 'South African Rand', decimals: 2 },
]

export function findIsoCurrency(code: string): IsoCurrency | undefined {
  return ISO_CURRENCIES.find(c => c.code === code.toUpperCase())
}
